import {
  ConfirmationDialogV2,
  ErpDataTableV2,
  ErpInputTableV2,
  LoadingOverlayV2,
  BulkDeleteDialogV4
} from '@/components/custom/erp';
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from '@/components/ui/resizable';

import { DonHangSearchProvider, useDonHangPage } from './context';
import { INPUT_TABLE_COLUMNS } from './cols-definition';
import SearchDialog from './components/search-dialog';
import FormDialog from './components/form-dialog';
import { TABLE_PAGE_SIZE } from './constants';
import { ActionBar } from './components';

function DonHangPageContent() {
  const page = useDonHangPage();

  return (
    <div className='flex h-screen w-full flex-col overflow-hidden'>
      {page.searchDialog.open && (
        <SearchDialog
          open={page.searchDialog.open}
          onClose={page.searchDialog.onClose}
          onSearch={page.searchDialog.onSubmit}
          initialSearchValues={page.searchDialog.searchParams}
          searchField={{
            state: page.searchDialog.searchFieldState,
            actions: page.searchDialog.searchFieldActions
          }}
        />
      )}

      {page.formDialog.open && (
        <FormDialog
          formMode={page.formDialog.formMode}
          open={page.formDialog.open}
          onClose={page.formDialog.onClose}
          initialData={
            page.formDialog.formMode === 'add' && !page.formDialog.isCopyMode ? undefined : page.formDialog.detail
          }
          onSubmit={page.formDialog.onSubmit}
          onAdd={page.formDialog.onAdd}
          onEdit={page.formDialog.onEdit}
          onDelete={page.formDialog.onDelete}
          onCopy={page.formDialog.onCopy}
        />
      )}

      {page.deleteDialog.open && (
        <ConfirmationDialogV2
          open={page.deleteDialog.open}
          onClose={page.deleteDialog.onClose}
          onConfirm={async () => {
            if (page.deleteDialog.selectedObj?.uuid) {
              await page.deleteDialog.deleteObj(page.deleteDialog.selectedObj.uuid);
            }
            page.deleteDialog.clearSelection();
            page.deleteDialog.onClose();
          }}
        />
      )}

      {page.bulkDeleteDialog.open && (
        <BulkDeleteDialogV4
          title='Đơn hàng'
          onClose={page.bulkDeleteDialog.onClose}
          columns={page.table.columns}
          dataRows={page.table.displayData}
          handleDelete={page.bulkDeleteDialog.onDelete}
        />
      )}

      <div className={`flex h-full flex-col ${page.formDialog.open ? 'hidden' : ''}`}>
        <ActionBar
          onAdd={page.actions.handleAddClick}
          onEdit={page.actions.handleEditClick}
          onDelete={page.actions.handleDeleteClick}
          onCopy={page.actions.handleCopyClick}
          onSearch={page.actions.handleSearch}
          onRefresh={page.actions.handleRefresh}
          isEditDisabled={!page.selection.selectedObj}
        />

        <div data-excel-operation-overlay-root className='min-h-0 flex-1 overflow-hidden'>
          <ResizablePanelGroup direction='vertical' className='h-full overflow-hidden'>
            <ResizablePanel defaultSize={55} minSize={20}>
              <div className='h-full w-full overflow-hidden'>
                <ErpDataTableV2
                  tables={page.table.tables}
                  onRowClick={page.actions.handleRowClick}
                  selectedRowId={page.selection.selectedRowIndex || undefined}
                  totalItems={page.table.totalItems}
                  currentPage={page.table.currentPage}
                  onPageChange={page.table.onPageChange}
                  onSearchChange={page.table.onSearchChange}
                  pageSize={TABLE_PAGE_SIZE}
                  loading={page.table.displayIsLoading}
                />
              </div>
            </ResizablePanel>

            <ResizableHandle withHandle className='bg-slate-200/80 hover:bg-slate-300' />

            <ResizablePanel defaultSize={45} minSize={20}>
              <div className='h-full overflow-hidden'>
                <ErpInputTableV2
                  rows={page.selection.selectedObj ? page.detailTable.rows : []}
                  columns={INPUT_TABLE_COLUMNS}
                  showIndexColumn
                  actions={{
                    export: () => console.log('Export clicked'),
                    pin: () => console.log('Pin clicked')
                  }}
                  actionsDisabled={page.formDialog.formMode === 'view' || !page.selection.selectedObj}
                  height='100%'
                  loading={page.table.displayIsLoading && !page.selection.selectedObj}
                />
              </div>
            </ResizablePanel>
          </ResizablePanelGroup>
        </div>
      </div>
    </div>
  );
}

export default function DonHangPage() {
  return (
    <DonHangSearchProvider>
      <DonHangPageContent />
    </DonHangSearchProvider>
  );
}
